import axios from '../../axios'

// 新增录取公式
export const addEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula',
        method: 'POST',
        data
    })
}

// 修改录取公式
export const editEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula',
        method: 'PUT',
        data
    })
}

// 获取录取公式详情
export const getEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula',
        method: 'GET',
        data
    })
}

// 删除录取公式
export const deleteEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula',
        method: 'DELETE',
        data
    })
}

// 获取录取公式列表
export const getEnrollformulaList = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula',
        method: 'GET',
        data
    })
}

// 导入录取公式
export const importEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula/import',
        method: 'POST',
        data
    })
}

// 导出录取公式
export const exportEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula/export',
        method: 'POST',
        data
    })
}

// 批量更新录取公式
export const updateEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula/batch/update',
        method: 'POST',
        data
    })
}

// 批量删除录取公式
export const allDeleteEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula/batch/delete',
        method: 'POST',
        data
    })
}

// 对比导出录取公式
export const diffExportEnrollformula = (data) => {
    return axios({
        url: '/api/data/wish/admission/enroll/formula/check',
        method: 'POST',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/enrollformula.js